import { defineRule, configure } from 'vee-validate';
import { required, email, min, max, confirmed, regex, integer } from '@vee-validate/rules';
import i18n from './i18n';

// Define rules
defineRule('required', required);
defineRule('email', email);
defineRule('min', min);
defineRule('max', max);
defineRule('confirmed', confirmed);
defineRule('regex', regex);
defineRule('integer', integer);

// Configure vee-validate with localized messages
configure({
  generateMessage: context => {
    const { t } = i18n.global;

    // Get the base message template
    const messageKey = `validation.${context.rule.name}`;

    // Create parameters object for i18n
    const params = {
      field: context.label || context.field,
    };

    // Handle specific rule parameters
    if (context.rule.name === 'min' || context.rule.name === 'max') {
      params.length = context.rule.params[0];
    }

    return t(messageKey, params);
  },
});
